<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>
      <div class="loadertext" v-if="this.isLoading"> {{ $t('loadingTxt') }}...</div>
      <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
  
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
  
        <div class="page-wrapper">
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
  
              <div class="col-lg-12 col-xl-12 stretch-card">
                <div class="card">
                  <div class="card-header">
                    <h4 style="margin-right: 5px" class="float-start">Blujay BCA Master Location</h4>
                    <button v-if="permision_role.method_create" class="btn btn-primary float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="createData()">
                      <i class="link-icon mdi mdi-plus"></i>
                      {{ $t("createNew") }}
                    </button>
  
                    <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="downloadData()">
                      <i class="link-icon mdi mdi-download"></i>
                      {{ $t("downloadData") }} .xlsx
                    </button>
                    
  
                  </div>
  
                  <div class="card-body">
                    <vue-good-table title="blujay-bca-master-location" ref="blujay-bca-master-location"
                      mode="remote" @on-page-change="onPageChange"
                      @on-sort-change="onSortChange" @on-column-filter="onColumnFilter" 
                     
                      @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :line-numbers="true"
                      :isLoading.sync="isLoading" :pagination-options="{
                       
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                      }" :rows="rows" :columns="columns">
  
                  
 
  
                      <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'actions'">
                          <a href="#" v-if="permision_role.method_read" title="Detail" @click.prevent="
                            detailData(props.index, props.row)
                            ">
                            <i class="mdi mdi-eye" style="font-size:16px"></i>
  
                          </a>
                          <a href="#" v-if="permision_role.method_update" title="Edit"
                            @click.prevent="editData(props.index, props.row)">
                            <i class="mdi mdi-square-edit-outline" style="font-size:16px"></i>
  
                          </a>
    
                        </span>
                        <span v-else>
                          {{ props.formattedRow[props.column.field] }}
                        </span>
                      </template>
                    </vue-good-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
  
   
  
  
  
  
  
          <!--begin::modal-->

            <modal name="createLocation" :draggable="false" :scrollable="true" :height="'auto'">
                <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true"
                role="dialog">
                <div class="modal-dialog  modal-xl">
                    <div class="modal-content">
    
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Create New Location</h5>
                        <button type="button" class="btn btn-default"  @click.prevent="removeModals()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
    
                        <form class="forms-sample" @submit.prevent="submitData()" method="POST">

                            <div class="modal-body">

                                    <div class="mb-3">

                                        <label for="recipient-name" class="form-label">Location Code:</label>
                                        <input type="text" class="form-control" placeholder="Location Code" v-model="forms.location" :id="this.$dynamicId()" autocomplete="off" autofocus required/>
                                        <div v-if="errors.location">
                                        <div v-for="error in errors.location" :key="error" class="alert alert-primary" role="alert">
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                        </div>
                                        </div>

                                    </div>
                                    <div class="mb-3">

                                        <label for="message-text" class="form-label">Location Name:</label>
                                        <input type="text" class="form-control" placeholder="Location Name" v-model="forms.location_name" :id="this.$dynamicId()" autocomplete="off" required/>
                                        <div v-if="errors.location_name">
                                        <div v-for="error in errors.location_name" :key="error" class="alert alert-primary" role="alert">
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                        </div>
                                        </div>

                                    </div>

                            </div>
            
            
                            <div class="modal-footer justify-content-between">

                                <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
                                <button type="submit" class="btn btn-primary">{{this.$t("submitFormTxt")}}</button>
            

                            </div>
    
                        </form>
    
                    </div>
                </div>
                </div>
            </modal>


            <modal name="detailLocation" :draggable="false" :scrollable="true" :height="'auto'">
                <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true"
                role="dialog">
                <div class="modal-dialog  modal-xl">
                    <div class="modal-content">
    
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Detail Location</h5>
                        <button type="button" class="btn btn-default"  @click.prevent="removeModals()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
     
                            <div class="modal-body">

                                    <div class="mb-3">

                                        <label for="recipient-name" class="form-label">Location Code:</label>
                                        <input type="text" class="form-control" placeholder="Location Code" v-model="forms.location" :id="this.$dynamicId()" autocomplete="off" autofocus disabled/>
                                         

                                    </div>
                                    <div class="mb-3">

                                        <label for="message-text" class="form-label">Location Name:</label>
                                        <input type="text" class="form-control" placeholder="Location Name" v-model="forms.location_name" :id="this.$dynamicId()" autocomplete="off" disabled/>
                                         

                                    </div>

                            </div>
            
            
                            <div class="modal-footer justify-content-between">

                                <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
                             

                            </div>
     
    
                    </div>
                </div>
                </div>
            </modal>


            <modal name="editLocation" :draggable="false" :scrollable="true" :height="'auto'">
                <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true"
                role="dialog">
                <div class="modal-dialog  modal-xl">
                    <div class="modal-content">
    
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Edit Location</h5>
                        <button type="button" class="btn btn-default"  @click.prevent="removeModals()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
    
                        <form class="forms-sample" @submit.prevent="editSubmitData()" method="POST">

                            <div class="modal-body">

                                    <div class="mb-3">

                                        <label for="recipient-name" class="form-label">Location Code:</label>
                                        <input type="text" class="form-control" placeholder="Location Code" v-model="forms.location_new" :id="this.$dynamicId()" autocomplete="off" autofocus required/>
                                        <div v-if="errors.location">
                                        <div v-for="error in errors.location" :key="error" class="alert alert-primary" role="alert">
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                        </div>
                                        </div>

                                    </div>
                                    <div class="mb-3">

                                        <label for="message-text" class="form-label">Location Name:</label>
                                        <input type="text" class="form-control" placeholder="Location Name" v-model="forms.location_name" :id="this.$dynamicId()" autocomplete="off" required/>
                                        <div v-if="errors.location_name">
                                        <div v-for="error in errors.location_name" :key="error" class="alert alert-primary" role="alert">
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                        </div>
                                        </div>

                                    </div>

                            </div>
            
            
                            <div class="modal-footer justify-content-between">

                                <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
                                <button type="submit" class="btn btn-primary">{{this.$t("submitFormTxt")}}</button>
            

                            </div>
    
                        </form>
    
                    </div>
                </div>
                </div>
            </modal>

          <!--end::modal-->
  
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
  </template>
    
  <script>
  import navbarComponent from "@/components/_partials/_navbar";
  import footerComponent from "@/components/_partials/_footer";
  
  export default {
    name: "BlujayBcaMasterLocationIndex",
    components: {
      "navbar-component": navbarComponent,
      "footer-component": footerComponent,
    },
    data() {
      return {
        digit: {
            decimal: ',',
            thousands: '.',
            prefix: ' ',
            suffix: '',
            precision: 5,
            masked: false
          },
        locale:{
            format:"yyyy-mm-dd",
        
        },
        highlighted:{

        dates: [ // Highlight an array of dates
            new Date(),
        ],

        },
        dateTimes:'',
        fromDates: {
            startDate: null,
            endDate: null
        },
        firstDates:{
            startDate: null,
            endDate: null
        },
        filterOrderType:[],
        forms: {location:"",location_name:"" , location_new:""},
        maxToasts: 100,
        position: "up right",
        closeBtn: true,
        isLoading: false,
        errors: [],
        idAsnHeaders:[],
        permision_role: [],
        langs: ["id", "en"],
        detailUser: [],
        BAS_SKU_IDs: [],
        detailDivisi: [],
        totalRecords: 0,
        activeFlag : false,
        shelfLifeFlag : false,
        kitFlag : false,
        freePickGift : false,
        serverParams: {
          columnFilters: {},
          sort: {
            field: "",
            type: "",
          },
          page: 1,
          per_page: 10,
        },
       
        columns: [

            {
            label: 'Location',
            field: "location",
            thClass: 'text-center',
            filterOptions: {
              customFilter: false,
              enabled: true, // enable filter for this column
              placeholder: '', // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              trigger: "enter", //only trigger on enter not on keyup
            },
          },

            {
            label: 'Location Name',
            field: "location_name",
            thClass: 'text-center',
            filterOptions: {
              customFilter: false,
              enabled: true, // enable filter for this column
              placeholder: '', // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              trigger: "enter", //only trigger on enter not on keyup
            },
          }, 
         
          {
            label: this.$t("action_txt"),
            field: "actions",
            thClass: 'text-center',
            sortable: false,
            filterOptions: {
              customFilter: false,
            }
          },
        ],
        rows: [],
        rowsSelection: [],
        errorsDataSoUpload: false,
      };
    },
    watch: {},
    methods: {
  
   
        submitData() {

            this.isLoading = true;

    
            const baseURI = this.$settings.endPoint + "blujay-bca/location/store";
            this.$http.post(baseURI, this.forms, { timeout: 10000 }).then((response) => {
                this.loading();
                if (response.data.status === 200) {
                //this.resetForm();
                this.isLoading = false;
                this.errors = [];
                this.loadItems();
                this.removeModals();
                this.success('Berhasil');
                } else {
                this.isLoading = false;
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
                }
            }).catch(error => {
                this.loading();
                this.isLoading = false;
                if (error.code == "ECONNABORTED") {
                this.error("Please Check Your Internet Connection");
                }

                if (error.response) {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                } else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                } else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                } else {
                    this.$router.push('/page-not-found');
                }
                }
                //this.resetForm();
            });

        },

   
        editSubmitData() {

            this.isLoading = true;

            var formsSubmit = {location:this.forms.location_new , location_name:this.forms.location_name}
            const baseURI = this.$settings.endPoint + "blujay-bca/location/update/"+this.forms.location;
            this.$http.patch(baseURI, formsSubmit, { timeout: 10000 }).then((response) => {
                this.loading();
                if (response.data.status === 200) {
                //this.resetForm();
                this.isLoading = false;
                this.errors = [];
                this.loadItems();
                this.removeModals();
                this.success('Berhasil');
                } else {
                this.isLoading = false;
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
                }
            }).catch(error => {
                this.loading();
                this.isLoading = false;
                if (error.code == "ECONNABORTED") {
                this.error("Please Check Your Internet Connection");
                }

                if (error.response) {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                } else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                } else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                } else {
                    this.$router.push('/page-not-found');
                }
                }
                //this.resetForm();
            });

        },

  
 
        removeModals() {
            this.$modal.hide('createLocation')
            this.$modal.hide('detailLocation')
            this.$modal.hide('editLocation')
            this.forms.location         = ""
            this.forms.location_name    = ""
            this.forms.location_new     = ""
            this.errors                 = []
            this.loadItems();
    
        },
  
        downloadData() {

            const baseURI = this.$settings.endPoint + "blujay-bca/location/index";
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name = "download_" + CurrentDate + ".xlsx";
            
            return this.$http
            .get(
                baseURI +
                `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&location=${this.serverParams.columnFilters.location}&location_name=${this.serverParams.columnFilters.location_name}&download=download`,
    
                {
                responseType: "blob",
                }
            )
            .then((response) => {
    
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");
    
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.fade(false);
            });

        },
  
        createData() {
            this.forms.location         = ""
            this.forms.location_name    = ""
            this.errors                 = []
            this.$modal.show('createLocation')
        },
  
  
        editData(index, row) {
            this.forms.location         = row.location
            this.forms.location_name    = row.location_name
            this.forms.location_new     = row.location
            this.$modal.show('editLocation')
        },
    
        detailData(index, row) {
            
            this.forms.location         = row.location
            this.forms.location_name    = row.location_name
            this.$modal.show('detailLocation')

        },
  
        deleteData(index, row, status) {
            this.$swal({
            title: this.$t("areYouSure"),
            text: this.$t("yourDataDelete"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
            }).then((result) => {
            if (result.value) {
                var formData = {
                status: status,
                };
                const baseURI =
                this.$settings.endPointFluxOms + "v2/asn/delete/" + row.BAS_SKU_ID;
                this.$http
                .delete(baseURI, formData, { timeout: 10000 })
                .then((response) => {
                    this.loading();
                    if (response.data.status === 200) {
                    this.success(response.data.datas.messages);
                    this.loadItems();
                    } else {
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                    }
                }).catch((error) => {
                    this.loading();
    
                    if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
    
                    } else {
    
    
                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));
    
                    } else {
    
                        if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        } else {
                            this.$router.push('/page-not-found');
                        }
                        }
    
                    }
    
                    }
                });
            } else {
                this.isLoading = false;
            }
            });
        },


        cancelData(index, row, status) {
            console.log(status);
            this.$swal({
            title: this.$t("areYouSure"),
            text: this.$t("yourDataCancel"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
            }).then((result) => {
            if (result.value) {
                
                const baseURI =
                this.$settings.endPointFluxOms + "v2/asn/cancelled/" + row.idAsnHeader;
                this.$http
                .patch(baseURI, { timeout: 10000 })
                .then((response) => {
                    this.loading();
                    if (response.data.status === 200) {
                    this.success(response.data.datas.messages);
                    this.loadItems();
                    } else {
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                    }
                }).catch((error) => {
                    this.loading();
    
                    if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
    
                    } else {
    
    
                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));
    
                    } else {
    
                        if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        } else {
                            this.$router.push('/page-not-found');
                        }
                        }
    
                    }
    
                    }
                });
            } else {
                this.isLoading = false;
            }
            });
        },
  
        // load items is what brings back the rows from server
        loadItems() {
            const baseURI = this.$settings.endPoint + "blujay-bca/location/index";
            this.isLoading = true;
            
            return this.$http
            .get(
                baseURI +
                `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&location=${this.serverParams.columnFilters.location}&location_name=${this.serverParams.columnFilters.location_name}`,
                { timeout: 10000 })
            .then((response) => {
                this.isLoading = false;
                this.rows = response.data.datas.data;
            

                this.totalRecords = response.data.datas.total;
            }).catch((error) => {
                this.loading();
    
                if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
    
                } else {
    
                if (error.response) {
                    if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                    this.logout();
                    } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                    } else {
                    this.$router.push('/page-not-found');
                    }
                }
    
                }
            });
        },

  
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            this.loadItems();
        },
  
        onColumnFilter(params) {
            this.updateParams(params);
        },
    
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
        },
    
        onSortChange(params) {
            this.updateParams({
            sort: {
                type: params[0].type,
                field: params[0].field,
            },
            });
        },
    
        onPerPageChange(params) {
            this.updateParams({ per_page: params.currentPerPage });
        },
    
        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
            var nameOb = Object.keys(data)[x];
            var objectData = data[nameOb];
            for (var y = 0; y < objectData.length; y++) {
                this.error(objectData[y]);
            }
            }
        },
  
        success(kata) {
            const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
            });
            Toast.fire({
            icon: "success",
            title: kata,
            });
        },
    
        error(kata) {
            const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
            });
            Toast.fire({
            icon: "error",
            title: kata,
            });
        },
    
        fade(sType) {
            this.isLoading = sType;
        },
    
        loading() {
            this.fade(true);
            setTimeout(() => {
            this.isLoading = false;
            }, 1000); // hide the message after 3 seconds
        },
    
        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
            // console.log(permision.permission.controller);
            if (permision.permission.controller == 'LocationController') {
                rolePermision = permision;
            }
            });
    
            if (!rolePermision.method_read) {
            this.$router.push("/authorized-error");
            }
            this.permision_role = rolePermision;
    
        },
    
    
        logout() {
    
            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
    
            console.log(response);
    
            });
    
            this.$logoutUser();
            window.location.href = '/';
        },
      
    },
    events: {},
    created: function () { },
    
    mounted() {
      this.fetchIt();
      this.loading();
    },
  };
  </script>
  <style scoped>
  .blur-content {
    filter: blur(5px);
  }
  </style>